import { lazy } from "react";

export const CreateHospitalAsync = lazy(() => import("./CreateHospital"));
